import { createContext, useCallback, useContext, useRef, useState, type ReactNode } from 'react';
import { Icon } from '../ui/Icon.tsx';

interface ToastState { msg: string; kind: 'ok' | 'warn'; undo?: () => void | Promise<void> }
type Show = (msg: string, kind?: 'ok' | 'warn', undo?: () => void | Promise<void>) => void;

const Ctx = createContext<Show>(() => {});
// o aviso pertence à tela em que nasceu: trocar de tela o tira de vista (main.tsx chama ao navegar)
export const toastBus = { clear: () => {} };

export function ToastProvider({ children }: { children: ReactNode }) {
  const [t, setT] = useState<ToastState | null>(null);
  const timer = useRef<number>(0);
  const shownAt = useRef(0);
  const show = useCallback<Show>((msg, kind = 'ok', undo) => {
    window.clearTimeout(timer.current);
    shownAt.current = Date.now();
    setT({ msg, kind, undo });
    timer.current = window.setTimeout(() => setT(null), undo ? 6500 : 3600);
  }, []);
  // aviso que acabou de nascer (a ação que trocou de tela) fica; o da tela anterior sai
  toastBus.clear = () => { if (Date.now() - shownAt.current < 500) return; window.clearTimeout(timer.current); setT(null); };
  return (
    <Ctx.Provider value={show}>
      {children}
      {t && (
        <div className={'toast' + (t.kind === 'warn' ? ' warn' : '')} role="status">
          <Icon name={t.kind === 'warn' ? 'info' : 'check'} />
          <span>{t.msg}</span>
          {t.undo && <button onClick={async () => { const u = t.undo!; setT(null); await u(); }}>Desfazer</button>}
        </div>
      )}
    </Ctx.Provider>
  );
}

export const useToast = () => useContext(Ctx);
